<script setup lang="ts">
// Lock screen where Sobes notifications arrive one by one while it is on screen.
import { useElementVisibility, useIntervalFn } from '@vueuse/core'

const notifications = [
  { title: 'Приглашение на стажировку', text: 'Кофейня «Зерно» ждёт тебя в субботу в 8:00 на Ленина, 12', time: 'сейчас' },
  { title: 'Кофейня «Зерно»', text: 'Отлично! Фартук выдадим 😊', time: '2 мин' },
  { title: 'Твоё видео посмотрели', text: '12 работодателей открыли твоё видеорезюме за неделю', time: '1 ч' },
]

const root = useTemplateRef<HTMLElement>('root')
const visible = useElementVisibility(root)
const shown = ref(1)

const { pause, resume } = useIntervalFn(() => {
  shown.value = shown.value >= notifications.length + 1 ? 1 : shown.value + 1
}, 1800, { immediate: false })
watch(visible, value => value ? resume() : pause())
</script>

<template>
  <div ref="root" class="relative flex size-full flex-col items-center overflow-hidden bg-linear-to-b from-violet-700 via-fuchsia-600 to-orange-400 px-3 pt-16 text-white">
    <div class="absolute -left-20 top-40 size-72 rounded-full bg-white/20 blur-3xl" />
    <Icon name="tabler:lock-filled" class="relative size-5 opacity-90" />
    <p class="relative mt-1 text-sm font-medium opacity-90">суббота, 11 октября</p>
    <p class="relative text-[5.5rem] font-semibold leading-none tracking-tight">7:42</p>

    <TransitionGroup
      tag="ul"
      class="relative mt-auto mb-10 flex w-full flex-col gap-2"
      enter-from-class="translate-y-6 scale-95 opacity-0"
      enter-active-class="transition duration-500"
      leave-to-class="opacity-0"
      leave-active-class="transition duration-300 absolute"
    >
      <li
        v-for="item in notifications.slice(0, Math.min(shown, notifications.length)).reverse()"
        :key="item.title"
        class="flex gap-3 rounded-[1.4rem] bg-white/75 p-3 text-neutral-950 shadow-lg backdrop-blur-xl"
      >
        <span class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-white">
          <Icon name="local:logo" class="size-7" />
        </span>
        <span class="min-w-0 flex-1">
          <span class="flex items-center justify-between gap-2 text-[15px] font-semibold">
            <span class="truncate">{{ item.title }}</span>
            <span class="shrink-0 text-xs font-normal text-neutral-500">{{ item.time }}</span>
          </span>
          <span class="mt-0.5 block text-sm leading-snug text-neutral-700">{{ item.text }}</span>
        </span>
      </li>
    </TransitionGroup>
  </div>
</template>
